"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _consts = require("./../consts.js");

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzBand__Wrapper",
  componentId: "sc-yt1fmg-0"
})(["\n  width: 100%;\n  padding: ", ";\n\n  ", ";\n\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"], function (props) {
  return props.padding;
}, function (props) {
  return props.variant === "default" ? "\n    background-color: transparent;\n  " : function (props) {
    return props.variant === "white" ? "\n    background-color: #ffffff;\n  " : function (props) {
      return props.variant === "silvertree-light" ? "\n    background-color: #EDFBF2;\n  " : function (props) {
        return props.variant === "silvertree-medium" ? "\n    background-color: #DCF6E7;\n  " : function (props) {
          return props.variant === "silvertree" ? "\n    background-color: ".concat(_consts.SILVERTREE, ";\n  ") : function (props) {
            return props.variant === "chetwodeblue-light" ? "\n    background-color: #EFF1FC;\n  " : function (props) {
              return props.variant === "chetwodeblue-medium" ? "\n    background-color: #E0E5FF;\n  " : function (props) {
                return props.variant === "chetwodeblue" ? "\n    background-color: ".concat(_consts.CHETWODEBLUE, ";\n  ") : function (props) {
                  return props.variant === "whitesmoke" ? "\n    background-color: #F1F2F5;\n  " : function (props) {
                    return props.variant === "blackpearl" ? "\n    background-color: ".concat(_consts.BLACKPEARL, ";\n  ") : null;
                  };
                };
              };
            };
          };
        };
      };
    };
  };
});

var OzBand = function OzBand(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "default" : _ref$variant,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? "70px 0px" : _ref$padding,
      children = _ref.children;
  return __jsx(Wrapper, {
    variant: variant,
    padding: padding
  }, children);
};

var _default = OzBand;
exports.default = _default;